require('../../node_modules/jquery-validation/dist/jquery.validate');
require('../../node_modules/jquery-validation/dist/additional-methods.js');
require('./bootstrap');
require('../../node_modules/bootstrap-select/js/bootstrap-select');
require('../../node_modules/select2/dist/js/select2.full');
